export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";